import {
  getSuppliersApi,
  getSupplierApi,
  updateSupplierApi,
  getSuppliersListApi,
  uploadShippingApi,
  getSupplierShippingPricesApi,
  upsertSupplierShippingPriceApi,
  downloadInventoryFileFormatApi,
  downloadShippingFileFormatApi,
  getSftpConnectionsApi,
  createSftpConnectionApi,
  updateSftpConnectionApi,
  deleteSftpConnectionApi,
} from './suppliers.api';
import { ToastUtil } from '../utils/toast.util';

export const getSuppliersReducers = (builder) => {
  builder
    .addCase(getSuppliersApi.pending, (state) => {
      state.getSuppliersStatus = 'pending';
    })
    .addCase(getSuppliersApi.fulfilled, (state, { payload }) => {
      state.getSuppliersStatus = 'fulfilled';
      state.suppliers = payload.suppliers;
      state.totalSuppliers = payload.totalCount;
      state.totalPages = payload.totalPages;
      state.currentPage = payload.currentPage;
    })
    .addCase(getSuppliersApi.rejected, (state, action) => {
      state.getSuppliersStatus = 'failed';
      state.error = action?.error?.message;
    });
};

export const getSupplierReducers = (builder) => {
  builder
    .addCase(getSupplierApi.pending, (state) => {
      state.getSupplierStatus = 'pending';
      state.error = null;
    })
    .addCase(getSupplierApi.fulfilled, (state, action) => {
      state.getSupplierStatus = 'fulfilled';
      state.supplier = action.payload;
      state.error = null;
    })
    .addCase(getSupplierApi.rejected, (state, action) => {
      state.getSupplierStatus = 'rejected';
      state.error = action?.error?.message;
    });
};

export const updateSupplierReducers = (builder) => {
  builder
    .addCase(updateSupplierApi.pending, (state) => {
      state.updateSupplierStatus = 'pending';
      state.error = null;
    })
    .addCase(updateSupplierApi.fulfilled, (state, {payload}) => {
      state.updateSupplierStatus = 'fulfilled';
      state.supplier = payload.data;
      state.error = payload.message;

      ToastUtil.handleApiResponse(payload, 'Update Successful', 'Update Failed');
    })
    .addCase(updateSupplierApi.rejected, (state, action) => {
      state.updateSupplierStatus = 'rejected';
      state.error = action?.error?.message;
      ToastUtil.error(
        'Update failed',
        action?.error?.message || 'Failed to update supplier',
      );
    });
};

export const getSuppliersListReducers = (builder) => {
  builder
    .addCase(getSuppliersListApi.pending, (state) => {
      state.getSuppliersListStatus = 'pending';
    })
    .addCase(getSuppliersListApi.fulfilled, (state, { payload }) => {
      state.getSuppliersListStatus = 'fulfilled';
      state.list = payload;
    })
    .addCase(getSuppliersListApi.rejected, (state, action) => {
      state.getSuppliersListStatus = 'failed';
      state.error = action?.error?.message;
    });
};

export const getSupplierShippingPricesReducers = (builder) => {
  builder
    .addCase(getSupplierShippingPricesApi.pending, (state) => {
      state.getShippingPricesStatus = 'pending';
    })
    .addCase(getSupplierShippingPricesApi.fulfilled, (state, { payload }) => {
      state.getShippingPricesStatus = 'fulfilled';
      state.shippingPricesPage = payload;
    })
    .addCase(getSupplierShippingPricesApi.rejected, (state, action) => {
      state.getShippingPricesStatus = 'failed';
      state.error = action?.error?.message;
    });
};

export const upsertSupplierShippingPriceReducers = (builder) => {
  builder
    .addCase(upsertSupplierShippingPriceApi.pending, (state) => {
      state.upsertShippingPriceStatus = 'pending';
    })
    .addCase(upsertSupplierShippingPriceApi.fulfilled, (state, { payload }) => {
      state.upsertShippingPriceStatus = 'fulfilled';
      ToastUtil.handleApiResponse(
        payload,
        'Shipping price saved',
        'Failed to save shipping price',
      );
    })
    .addCase(upsertSupplierShippingPriceApi.rejected, (state, action) => {
      state.upsertShippingPriceStatus = 'failed';
      ToastUtil.error(
        'Failed to save shipping price',
        action?.error?.message || 'Update failed',
      );
    });
};

export const uploadShippingReducers = (builder) => {
  builder
    .addCase(uploadShippingApi.pending, (state) => {
      state.uploadShippingStatus = 'pending';
    })
    .addCase(uploadShippingApi.fulfilled, (state, { payload }) => {
      state.uploadShippingStatus = 'fulfilled';
      state.error = payload.message;
      if (state.supplier && payload?.data) {
        state.supplier = {
          ...state.supplier,
          shippingUpdatedDate: new Date().toISOString(),
        };
      }

      ToastUtil.handleApiResponse(payload, 'Upload Successful', 'Upload Failed');
    })
    .addCase(uploadShippingApi.rejected, (state, action) => {
      state.uploadShippingStatus = 'failed';
      state.error = action.error.message;
      ToastUtil.error(
        'Upload failed',
        action?.error?.message || 'Failed to upload shipping file',
      );
    });
};

export const downloadInventoryFileFormatReducers = (builder) => {
  builder
    .addCase(downloadInventoryFileFormatApi.pending, (state) => {
      state.downloadInventoryFormatStatus = 'pending';
    })
    .addCase(downloadInventoryFileFormatApi.fulfilled, (state) => {
      state.downloadInventoryFormatStatus = 'fulfilled';
    })
    .addCase(downloadInventoryFileFormatApi.rejected, (state, action) => {
      state.downloadInventoryFormatStatus = 'failed';
      state.error = action?.error?.message;
    });
};

export const downloadShippingFileFormatReducers = (builder) => {
  builder
    .addCase(downloadShippingFileFormatApi.pending, (state) => {
      state.downloadShippingFormatStatus = 'pending';
    })
    .addCase(downloadShippingFileFormatApi.fulfilled, (state) => {
      state.downloadShippingFormatStatus = 'fulfilled';
    })
    .addCase(downloadShippingFileFormatApi.rejected, (state, action) => {
      state.downloadShippingFormatStatus = 'failed';
      state.error = action?.error?.message;
    });
};

export const getSftpConnectionsReducers = (builder) => {
  builder
    .addCase(getSftpConnectionsApi.pending, (state) => {
      state.getSftpConnectionsStatus = 'pending';
    })
    .addCase(getSftpConnectionsApi.fulfilled, (state, { payload }) => {
      state.getSftpConnectionsStatus = 'fulfilled';
      state.sftpConnections = Array.isArray(payload) ? payload : [];
    })
    .addCase(getSftpConnectionsApi.rejected, (state, action) => {
      state.getSftpConnectionsStatus = 'failed';
      state.error = action?.error?.message;
    });
};

export const createSftpConnectionReducers = (builder) => {
  builder
    .addCase(createSftpConnectionApi.pending, (state) => {
      state.createSftpConnectionStatus = 'pending';
    })
    .addCase(createSftpConnectionApi.fulfilled, (state, { payload }) => {
      state.createSftpConnectionStatus = 'fulfilled';
      ToastUtil.handleApiResponse(payload, 'SFTP connection created', 'Failed to create');
    })
    .addCase(createSftpConnectionApi.rejected, (state, action) => {
      state.createSftpConnectionStatus = 'failed';
      ToastUtil.error('Failed to create SFTP connection', action?.error?.message);
    });
};

export const updateSftpConnectionReducers = (builder) => {
  builder
    .addCase(updateSftpConnectionApi.pending, (state) => {
      state.updateSftpConnectionStatus = 'pending';
    })
    .addCase(updateSftpConnectionApi.fulfilled, (state, { payload }) => {
      state.updateSftpConnectionStatus = 'fulfilled';
      ToastUtil.handleApiResponse(payload, 'SFTP connection updated', 'Failed to update');
    })
    .addCase(updateSftpConnectionApi.rejected, (state, action) => {
      state.updateSftpConnectionStatus = 'failed';
      ToastUtil.error('Failed to update SFTP connection', action?.error?.message);
    });
};

export const deleteSftpConnectionReducers = (builder) => {
  builder
    .addCase(deleteSftpConnectionApi.pending, (state) => {
      state.deleteSftpConnectionStatus = 'pending';
    })
    .addCase(deleteSftpConnectionApi.fulfilled, (state, { payload }) => {
      state.deleteSftpConnectionStatus = 'fulfilled';
      ToastUtil.handleApiResponse(payload, 'SFTP connection deleted', 'Failed to delete');
    })
    .addCase(deleteSftpConnectionApi.rejected, (state, action) => {
      state.deleteSftpConnectionStatus = 'failed';
      ToastUtil.error('Failed to delete SFTP connection', action?.error?.message);
    });
};
